import React, { AnchorHTMLAttributes } from 'react';
import Icon from '../Icon/icon';
import { cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { IconNames } from '../../util/types';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  text: string;
  href: string;
  type?: 'default' | 'inline';
  iconName?: IconNames;
}

const linkVariantStyle = cva(
  [
    'preflight',
    '!ds-font-sans',
    'ds-inline-flex',
    'ds-items-center',
    'ds-gap-1',
    'ds-flex-direction-row',
    'ds-cursor-pointer',
    'ds-text-acuity-blue',
    'active:ds-text-acuity-blue-darkest',
    'focus-visible:ds-outline-none',
    'focus-visible:ds-border-2',
    'focus-visible:ds-rounded',
    'focus-visible:ds-border-acuity-blue',
    'focus-visible:ds-px-[2px]',
    'focus-visible:ds-py-[2px]',
    'focus-visible:-ds-mx-[4px]',
    'focus-visible:-ds-my-[4px]'
  ],
  {
    variants: {
      type: {
        default: ['ds-font-bold', 'hover:ds-underline'],
        inline: [
          'ds-underline',
          'hover:ds-no-underline',
          'active:ds-no-underline',
          'visited:ds-text-[#551A8B]'
        ]
      }
    }
  }
);

const Link: React.FC<LinkProps> = ({
  text,
  href,
  type = 'default',
  iconName,
  ...props
}) => {
  return (
    <a href={href} type={type} className={twMerge(linkVariantStyle({ type }))} {...props}>
      {text}
      {iconName && <Icon altText={text} name={iconName} size="small" />}
    </a>
  );
};

export default Link;
